module.exports = __webpack_public_path__ + "assets/img/page4-nav-item-12-b912ec8f.png";